import type { HttpPort, ILocaleService, LanguageRef } from "../contracts";
import { mapLanguage } from "./mappers";
import { modelKeyToPath } from "./query";

export class LocaleService implements ILocaleService {
    constructor(private readonly http: HttpPort) {}

    async listLanguages(): Promise<LanguageRef[]> {
        const res = await this.http.post<{ records?: unknown[] }>(`/api/records/${modelKeyToPath("res.language")}/search`, {
            domain: [["is_active", "=", true]],
            fields: ["record_uuid", "code", "name", "native_name", "direction"],
            order: "name",
        });
        return (res.records ?? []).map(mapLanguage);
    }

    async setUserLanguage(userId: string, languageId: string): Promise<void> {
        await this.http.put(`/api/records/${modelKeyToPath("res.user")}/${encodeURIComponent(userId)}`, {
            language_id: languageId,
        });
    }
}
